
export enum MetricStageCd {
	DISPATCHED = 'Dispatched',
	DOCK = 'Dock',
	PLANNING = 'Planning',
	POST_OPTIMIZER = 'PostOptimizer',
	POST_OPT_ROUTES = 'PostOptRoutes'}

